export const drugsListMapping_style = {
  dividerSx: {
    height: '20px',
    border: '1px solid',
    borderColor: '#E2E2E2',
    backgroundColor: '#E2E2E2',
    mt: '-1px',
  },
};
